export const passCSSVariable = (cssVar: string, cssVarValue: number | string | undefined) => {
    if (cssVarValue !== undefined) {
        return {
            [`--${cssVar}`]: cssVarValue,
        } as React.CSSProperties
    }

    return {}
}
